import { BYE_ID } from './round-robin'

function nextPowerOfTwo(value) {
  let n = 1
  while (n < value) {
    n *= 2
  }
  return n
}

export function buildKnockoutBracket(participants) {
  const cleanParticipants = participants.filter(Boolean)
  if (cleanParticipants.length < 2) {
    return { fixtures: [], bracket: null }
  }

  const size = nextPowerOfTwo(cleanParticipants.length)
  const slots = [...cleanParticipants]
  while (slots.length < size) {
    slots.push(BYE_ID)
  }

  const totalRounds = Math.log2(size)
  const fixtures = []

  for (let round = 1; round <= totalRounds; round++) {
    const matchesInRound = size / Math.pow(2, round)
    for (let slot = 1; slot <= matchesInRound; slot++) {
      const id = `ko-r${round}-m${slot}`
      let nextMatchId = null
      let nextSlot = null

      if (round < totalRounds) {
        nextMatchId = `ko-r${round + 1}-m${Math.ceil(slot / 2)}`
        nextSlot = slot % 2 === 1 ? 1 : 2
      }

      fixtures.push({
        id,
        kind: 'knockout',
        round,
        match: slot,
        player1Identity: null,
        player2Identity: null,
        status: 'pending',
        winnerIdentity: null,
        score1: null,
        score2: null,
        nextMatchId,
        nextSlot,
      })
    }
  }

  const firstRound = fixtures.filter((fixture) => fixture.round === 1)
  firstRound.forEach((fixture, index) => {
    fixture.player1Identity = slots[index * 2]
    fixture.player2Identity = slots[index * 2 + 1]
  })

  return {
    fixtures,
    bracket: {
      size,
      rounds: totalRounds,
    },
  }
}
